import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../..';
import ShowAt from '../../../ShowAt/ShowAt';

export default function TimeLeft({
  showTimeLeft,
  formattedTimeLeft,
  showTimeEnded,
  showNextStage,
  infoIsFetched,
  ignoreTimeLeft,
}) {
  const renderedTimeLeft = ignoreTimeLeft ? '' : formattedTimeLeft;
  return (
    <>
      <ShowAt at={showTimeLeft && !!renderedTimeLeft}>
        <Text dontTranslate className="date-time" text={renderedTimeLeft} />
      </ShowAt>
      <ShowAt at={infoIsFetched}>
        <ShowAt at={!renderedTimeLeft && (showTimeEnded || showNextStage)}>
          <div className="d-flex gap-sm">
            {showTimeEnded && <Text text="common.stage_ended" />}
            {showNextStage && <Text text="common.next_phase" />}
          </div>
        </ShowAt>
      </ShowAt>
    </>
  );
}

TimeLeft.defaultProps = {
  showTimeLeft: false,
  formattedTimeLeft: '',
  showTimeEnded: false,
  showNextStage: false,
  infoIsFetched: false,
  ignoreTimeLeft: false,
};

TimeLeft.propTypes = {
  showTimeLeft: PropTypes.bool,
  formattedTimeLeft: PropTypes.string,
  showTimeEnded: PropTypes.bool,
  showNextStage: PropTypes.bool,
  infoIsFetched: PropTypes.bool,
  ignoreTimeLeft: PropTypes.bool,
};
